import { render } from "./AuditTrailTable.vue?vue&type=template&id=81c553d2"
import script from "./AuditTrailTable.vue?vue&type=script&lang=js"
export * from "./AuditTrailTable.vue?vue&type=script&lang=js"

import "./AuditTrailTable.vue?vue&type=style&index=0&id=81c553d2&lang=scss"

import exportComponent from "/home/mon3m/mon3m/dafater/ManageSPA/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__